export const CARD_ORIENTATION = {
  thumbnail_up: 'col',
  thumbnail_down: 'col-reverse',
  thumbnail_left: 'row',
  thumbnail_right: 'row-reverse',
  top_thumbnail: 'col',
  bottom_thumbnail: 'col',
}